import React, { Suspense } from "react";
import { BrowserRouter } from 'react-router-dom'
import { RoutesJSX } from './routing/Routes'
import { UserProvider } from '../context/provider/UserProvider'
import { SocketProvider } from '../context/provider/SocketProvider'
import { WebsocketProvider } from "../context/provider/WebsocketProvider";

import CacheBuster from "react-cache-buster";
import packageJson from '../../package.json'
import { SoundProvider } from "../context/provider/SoundProvider";

export const App = () => {
    const isProduction = process.env.NODE_ENV === 'production'
    const version = packageJson.version
    console.log("isProduction -> ",isProduction)
    console.log("version -> ",version)
    return (
        <>
            <CacheBuster
                currentVersion={version}
                isEnabled={isProduction}
            >
                <UserProvider>
                    <SocketProvider>
                        <WebsocketProvider>
                            <SoundProvider>
                                <Suspense fallback={<h1>Cargando...</h1>}>
                                    <BrowserRouter basename={process.env.REACT_APP_SUB_DIRECTORY}>
                                        <RoutesJSX />
                                    </BrowserRouter>
                                </Suspense>
                            </SoundProvider>
                        </WebsocketProvider>
                    </SocketProvider>
                </UserProvider>
            </CacheBuster>
        </>
    )
}
